import React from 'react';
import PropTypes from 'prop-types';

import {
  Typography,
} from '@material-ui/core';

import { makeStyles, useTheme } from '@material-ui/core/styles';

import {
  Done as DoneIcon,
  Error as ErrorIcon,
  SkipNext as SkipNextIcon,
  Timer as TimerIcon,
  DeviceUnknown as UnknownIcon,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
  },
  label: {
  },
  adornment: {
  },
}));

export function ExecutionResultSucceededIcon(props) {
  const theme = useTheme();
  return (
    <DoneIcon fontSize='small' htmlColor={theme.palette.success.main} {...props}/>
  );
}

export function ExecutionResultPendingIcon(props) {
  const theme = useTheme();
  return (
    <TimerIcon fontSize='small' htmlColor={theme.palette.info.main} {...props}/>
  );
}

export function ExecutionResultSkippedIcon(props) {
  const theme = useTheme();
  return (
    <SkipNextIcon fontSize='small' htmlColor={theme.palette.warning.main} {...props} />
  );
}

export function ExecutionResultFailedIcon(props) {
  const theme = useTheme();
  return (
    <ErrorIcon fontSize='small' htmlColor={theme.palette.error.main} {...props} />
  );
}

export default function ExecutionResult(props) {

  const { value, adornment } = props;

  const classes = useStyles();
  
  let AdornmentIcon=UnknownIcon;
  if(value==='PENDING') {
    AdornmentIcon=ExecutionResultPendingIcon;
  } else if(value==='FAILED') {
    AdornmentIcon=ExecutionResultFailedIcon;
  } else if(value==='SUCCEEDED') {
    AdornmentIcon=ExecutionResultSucceededIcon;
  } else if(value==='SKIPPED') {
    AdornmentIcon=ExecutionResultSkippedIcon;
  } else {
    return(null);
  }

  return(
    <div className={classes.root}>
      {adornment==='start'?<AdornmentIcon style={{ marginRight: '4px' }} className={classes.adornment}/>:null}
      <Typography variant='body2' className={classes.label}>{value}</Typography>
      {adornment==='end'?<AdornmentIcon style={{ marginLeft: '4px' }} className={classes.adornment}/>:null}
    </div>
  );

}

ExecutionResult.propTypes = {
  value: PropTypes.string,
  adornment: PropTypes.oneOf(['none','start','end']).isRequired,
};

ExecutionResult.defaultProps = {
  adornment: 'start'
};

